module.exports = __webpack_public_path__ + "static/media/map-mobile.3bec4d43.png";